export default [
  {
    path: '/rules/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'Rules',
        component: () => import('@/views/Rules/Rules.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: 'rulesEdit',
        name: 'RulesEdit',
        component: () => import('@/views/Rules/RulesEdit.vue'),
        meta: {
          prev: 'Rules'
        }
      },
      {
        path: 'rulesDetail/:id',
        name: 'RulesDetail',
        component: () => import('@/views/Rules/RulesDetail.vue'),
        meta: {
          prev: 'Rules'
        }
      }
    ]
  }
]
